import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { IconButton, Icon, Tooltip, Box, CircularProgress } from '@material-ui/core';

import { getUsuarios } from '../../store/actions/usuario';
import TituloPagina from '../../components/layout/TituloPagina';
import DataTableComponent from '../../components/form/DataTableComponent';

const Usuarios = props => {

    const {
        usuarios,
        getUsuarios,
        loading
    } = props;

    useEffect(_ => {
        getUsuarios();
    }, [getUsuarios]);

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            width: '70px',
            sortable: true,
        },
        {
            name: 'Nome',
            selector: (row) => row.nomeCompleto,
            sortable: true
        },
        {
            name: 'CPF',
            selector: (row) => row.cpfOuCnpj,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Telefone',
            selector: (row) => row.telefones[0],
            width: '130px',
        },
        {
            name: <>Data de<br />Nascimento</>,
            selector: (row) => row.dataNascimento,
            width: '110px',
            headerStyle: { whiteSpace: 'normal' },
        },
        {
            name: <>Data de<br />Cadastro</>,
            selector: (row) => row.dataCadastro,
            width: '160px',
            headerStyle: { whiteSpace: 'normal' },
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Editar Funcionário' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="editar" size='small' color='secondary' component={Link} to={{ pathname: `/usuarios/editar/${row.id}`, state: { from: window.location.pathname } }}><Icon>edit</Icon></IconButton>
                    </Tooltip>

                    <Tooltip title='Cadastrar/Editar Endereço' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="enderecos" size='small' color='secondary' href={`/enderecos/usuarios/${row.id}`}><Icon>add_location_alt</Icon></IconButton>
                    </Tooltip>
                    <Tooltip title='Perfil de Acesso' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="perfilAdmin" size="small" color="primary" onClick={() => console.log('Clicou para alterar adim')}><Icon>security</Icon></IconButton>
                    </Tooltip>
                </>
            ),
            width: '80px'
        }
    ];

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Usuários' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Box sx={{ height: '70vh' }}>
                <DataTableComponent
                    columns={columns}
                    data={usuarios}
                    visibleSearch={usuarios && usuarios.length > 0}
                    camposParaBusca={['nomeCompleto', 'email', 'cpfOuCnpj', 'dataNascimento']}
                />
            </Box>
        </>
    )
}

const mapStateToProps = state => ({
    usuarios: state.usuario.usuarios,
    loading: state.usuario.loading,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getUsuarios,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Usuarios);